module.exports = __webpack_public_path__ + "img/103-62-plan.359028d4.jpg";